import React, { useEffect, useState } from 'react';
import { Loader2, ShieldCheck, Phone, Building, Globe2 } from 'lucide-react';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export default function SettingsPage() {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard/whatsapp-info').then((r) => setInfo(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" data-testid="settings-heading">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Read-only view of your WhatsApp Business and account.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="glass-card p-5" data-testid="settings-whatsapp-credentials-card">
          <div className="flex items-center gap-2 mb-3"><Phone className="h-5 w-5 text-[#F25C2A]" /><h2 className="text-lg font-semibold">WhatsApp Business</h2></div>
          {loading ? (
            <div className="py-6 text-center"><Loader2 className="h-5 w-5 mx-auto animate-spin" /></div>
          ) : (
            <div className="space-y-2 text-sm">
              <Row label="Phone Number" value={info?.display_phone_number || '—'} />
              <Row label="Verified Name" value={info?.verified_name || '—'} />
              <Row label="Quality Rating" value={info?.quality_rating || '—'} />
              <Row label="Phone Number ID" value={info?.phone_number_id} mono />
              <Row label="WABA ID" value={info?.business_account_id} mono />
              <Row label="API Version" value={info?.api_version} mono />
            </div>
          )}
        </div>

        <div className="glass-card p-5">
          <div className="flex items-center gap-2 mb-3"><Building className="h-5 w-5 text-[#F25C2A]" /><h2 className="text-lg font-semibold">Business Account</h2></div>
          <div className="space-y-2 text-sm">
            <Row label="Business Name" value={info?.business_name || '—'} />
            <Row label="Account Owner" value={user?.email} />
          </div>
        </div>

        <div className="glass-card p-5">
          <div className="flex items-center gap-2 mb-3"><ShieldCheck className="h-5 w-5 text-[#0F6B45]" /><h2 className="text-lg font-semibold">Connections</h2></div>
          <div className="space-y-2 text-sm">
            <Row label="Database" value="Supabase Postgres — Connected" />
            <Row label="AI Provider" value="Google Gemini 2.5 Flash-Lite" />
            <Row label="Messaging" value="Meta WhatsApp Cloud API" />
          </div>
        </div>

        <div className="glass-card p-5">
          <div className="flex items-center gap-2 mb-3"><Globe2 className="h-5 w-5 text-[#F25C2A]" /><h2 className="text-lg font-semibold">Tips</h2></div>
          <ul className="text-sm text-muted-foreground space-y-1 list-disc pl-4">
            <li>Submit templates with sample variable values to speed up Meta approval.</li>
            <li>For media headers (image/video/PDF), upload media when creating each campaign.</li>
            <li>Use Groups to segment customers (e.g., Goa, Manali, Repeat).</li>
            <li>Schedule campaigns at off-peak hours for better delivery rates.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value, mono }) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-white/40 pb-2 last:border-0">
      <div className="text-muted-foreground">{label}</div>
      <div className={`text-right break-all ${mono ? 'font-mono text-xs' : 'font-medium'}`}>{value || '—'}</div>
    </div>
  );
}
